import React, { FC } from 'react';
import Style                                      from "./Transfer.style";
import { Transfer as AntTransfer, TransferProps } from "antd";
import { TransferItem }                           from 'antd/lib/transfer';

type TProps = TransferProps<TransferItem> & {
    header?: string[]
};

export const Transfer: FC<TProps> = ({ header, ...props }) => {
    return (
      <Style>
        { header && (
          <div className="transferHeader">
            <div className="headerEntry bold">{ header[0] }</div>
            { header[1] && <div className="headerEntry bold">{ header[1] }</div> }
          </div>
        )}
        <AntTransfer {...props} />
      </Style>
    );
}
